import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import {
  RentalPortalProfileHeaderFooterActionButton,
  RentalPortalProfileHeaderFooterAddNewText,
  RentalPortalProfileHeaderFooterHiddenMeasureLayer,
  RentalPortalProfileHeaderFooterMoreButton,
} from '../../RentalPortalProfileHeaderFooter'

import {
  QA_NAME_APPLICANT_PROFILE_FOOTER_ADD_NEW,
  QA_NAME_APPLICANT_PROFILE_FOOTER_MORE,
} from './RentalPortalApplicantProfileHeaderFooter.constants'
import { useApplicantProfileHeaderFooter } from './RentalPortalApplicantProfileHeaderFooter.hooks'
import { getApplicantProfileFooterMoreOptions } from './RentalPortalApplicantProfileHeaderFooter.utils'

import * as styles from './RentalPortalApplicantProfileHeaderFooter.module.css'

function RentalPortalApplicantProfileHeaderFooter({ isLoading }) {
  const { t } = useTranslation()

  const {
    actionHandlers,
    addNewTextMeasureRef,
    addNewTextRef,
    bookViewingModal,
    getActionButtonRef,
    handleContainerRef,
    handleSelectMoreOption,
    hasActions,
    hiddenActions,
    isOnlyMoreWithAddNewText,
    moreButtonMeasureRef,
    visibleActions,
  } = useApplicantProfileHeaderFooter()

  return isLoading || !hasActions ? null : (
    <div className={styles.footer}>
      <div className={styles.container} ref={handleContainerRef}>
        <div className={styles.bar}>
          <div
            className={classNames(styles.addNewTextWrapper, {
              [styles.compactEdgeButtonWrapper]: isOnlyMoreWithAddNewText,
            })}
            ref={addNewTextRef}
          >
            <RentalPortalProfileHeaderFooterAddNewText
              qaName={QA_NAME_APPLICANT_PROFILE_FOOTER_ADD_NEW}
            />
          </div>
          {visibleActions.map(
            ({ Icon, action, disabled, qaName, text, tooltipKey }) => (
              <RentalPortalProfileHeaderFooterActionButton
                Icon={Icon}
                disabled={disabled}
                key={action}
                qaName={qaName}
                text={text}
                tooltipKey={tooltipKey}
                wrapperRef={getActionButtonRef(action)}
                onClick={actionHandlers[action]}
              />
            )
          )}
          {hiddenActions.length > 0 ? (
            <RentalPortalProfileHeaderFooterMoreButton
              buttonClassName={
                isOnlyMoreWithAddNewText ? styles.compactEdgeButton : undefined
              }
              className={classNames(styles.moreButton, {
                [styles.compactEdgeButtonWrapper]: isOnlyMoreWithAddNewText,
              })}
              options={getApplicantProfileFooterMoreOptions({
                actions: hiddenActions,
                t,
              })}
              qaName={QA_NAME_APPLICANT_PROFILE_FOOTER_MORE}
              onSelectItem={handleSelectMoreOption}
            />
          ) : null}
        </div>
        <RentalPortalProfileHeaderFooterHiddenMeasureLayer
          addNewTextMeasureRef={addNewTextMeasureRef}
          moreButtonMeasureRef={moreButtonMeasureRef}
        />
      </div>
      {bookViewingModal}
    </div>
  )
}

export default RentalPortalApplicantProfileHeaderFooter
